export const messages = {
  en: {
    shopCommunity: {
      search: {
        title: 'Search Conditions',
        shopName: 'Shop Name',
        communityName: 'Community Name',
        state: 'Status'
      },
      list: {
        title: 'Community Shops'
      },
      table: {
        communityId: 'Community ID',
        communityName: 'Community Name',
        shopName: 'Shop Name',
        createTime: 'Entry Time',
        startTime: 'Start Time',
        endTime: 'End Time',
        state: 'Status'
      },
      state: {
        passed: 'Approved',
        rejected: 'Rejected'
      },
      fetchError: 'Failed to fetch shop community data'
    }
  },
  zh: {
    shopCommunity: {
      search: {
        title: '查询条件',
        shopName: '店铺名称',
        communityName: '园区名称',
        state: '状态'
      },
      list: {
        title: '园区商铺'
      },
      table: {
        communityId: '园区编码',
        communityName: '园区名称',
        shopName: '商铺名称',
        createTime: '入驻时间',
        startTime: '开始时间',
        endTime: '结束时间',
        state: '状态'
      },
      state: {
        passed: '审核通过',
        rejected: '审核不通过'
      },
fetchError: '获取园区商铺数据失败'
    }
  },
  'zh-TW': {
    shopCommunity: {
      search: {
        title: '查詢條件',
        shopName: '店鋪名稱',
        communityName: '小區名稱',
        state: '狀態'
      },
      list: {
        title: '小區商鋪'
      },
      table: {
        communityId: '小區編碼',
        communityName: '小區名稱',
        shopName: '商鋪名稱',
        createTime: '入駐時間',
        startTime: '開始時間',
        endTime: '結束時間',
        state: '狀態'
      },
      state: {
        passed: '審核通過',
        rejected: '審核不通過'
      },
      fetchError: '獲取小區商鋪數據失敗'
    }
  }
}